<template>
  <div class="content">
    <el-tabs class="tabs" v-model="activeName" type="card" @tab-click="handleClick" style="width: 1201px;">
      <el-tab-pane label="文理分科" name="first" @click="handleClick">
      </el-tab-pane>
      <el-tab-pane label="新高考" name="second" @click="handleClick">
      </el-tab-pane>
    </el-tabs>
    <div class="yuche">
      <p>您的{{data.new_year}}年位次为<span>{{data.rank}}</span>位</p>
    </div>
    <main class='flex' style="align-items: flex-start;">
      <div class="left">
        <div class="title">
          {{userInfo.subject_type_1==1?'理科':'文科'}}{{userInfo.score}}分同位分（近三年）
        </div>
        <div class="table flex">
          <div class="table-head">
            <p style="border-bottom: 1px solid #e9e2e2;">年份</p>
            <p>同位分</p>
          </div>
          <div class="table-main">
            <div class="flex" style="border-bottom: 1px solid #eaf0ff;">
              <p v-for="(item,index) in data.history" :key="index">{{item.year}}</p>
            </div>
            <div class="flex">
              <p v-for="(item,index) in data.history" :key="index">{{item.score}}</p>
            </div>
          </div>
        </div>

        <!-- 选择科目-->
        <div class="one " v-show="activeName!='first'">
          <div> <span style="color: gray;font-weight: bold;">选科定目标</span></div>
          <div class="flex" style="margin-top: 20px;">
            <div class="one1 flex">
              <span style="font-weight: bold;">首选科目:</span>
              <div> <template>
                  <el-radio-group v-model="radio" fill="#C10B17" text-color='#C10B17' size="medium">
                    <el-radio :label="1" fill="#C10B17" text-color='#C10B17'>物理</el-radio>
                    <el-radio :label="4" fill="#C10B17" text-color='#C10B17'>历史</el-radio>
                  </el-radio-group>
                </template>
              </div>
            </div>
            <div class="one1 flex" style="margin-left: 100px;">
              <span style="font-weight: bold;">再选科目:</span>
              <el-checkbox-group v-model="checkedCities" text-color='#C10B17' fill='#C10B17' style="text-align: left;"
                :max="2">
                <el-checkbox v-for="item in kemu" :label="item.value" :key="item.value" text-color='#C10B17'
                  fill='#C10B17'>{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <button @click="kemu_change" style=" margin-top: 20px;">确定</button>
        </div>
        <!-- 选择专业-->
        <!-- <div class="one" v-if="activeName!='first'">
          <div class="major">
            <span style="color: gray;font-weight: bold;">专业定目标</span>
            <div style="padding-top: 10px;">
              <span v-for="(item,index) in major" :class="index==checkedNo?'tab_active':'major_one'"
                @click="major_change(item,index)">
                {{item.name}}
              </span>
            </div>
            <div class="more_major">
              <div style="margin: 15px"></div>
              <el-checkbox-group v-model="params.major_type_list" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="(item1,index) in major[checkedNo].childrenNode" :label="item1.id" :key="index"
                  style="width: 150px;font-size: 16px;margin-bottom: 15px;">
                  {{item1.name}}
                </el-checkbox>
              </el-checkbox-group>
              <button @click="submit">确定</button>
            </div>
          </div>
        </div> -->
        <div class="title">
          {{userInfo.subject_type_1==1?'理科':'文科'}}{{userInfo.score}}分可上院校（{{data.new_year}}年）
        </div>
        <div class="search flex">
          <el-select style="width: 150px;height: 40px;" v-model="value" @change="change" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <div>
            <input placeholder="请输入内容" v-model="params.name" autocomplete="off" style="text-indent:14px;">
            <el-button style="color:#ffffff;background-color: #C10B17;!important;" icon="el-icon-search"
              @click="search()">搜索</el-button>
            </input>
          </div>

        </div>
        <div class="filter">
          <span :class="params.goal==0?'active':''" @click="add_score(0)">当前</span> <span @click="add_score(5)"
            :class="params.goal==5?'active':''"> {{userInfo.score+5}}分</span>
          <span @click="add_score(10)" :class="params.goal==10?'active':''">{{userInfo.score+10}}分</span><span
            @click="add_score(15)" :class="params.goal==15?'active':''">{{userInfo.score+15}}分</span>
        </div>
        <div class="schoolList" v-show="activeName=='first'">
          <div class="one flex" @click="goDetail(item)" v-for="(item,index) in data.list"
            style="justify-content: space-between;">
            <div class="flex"> <img :src="'https://yunzhixuanpro.fw366.cn/'+item.school.badge_img">
              <div class="info">
                <div><span class="name">{{item.school_name}}</span><span
                    class="address">院校代码：{{item.enroll_code}}</span>
                </div>
                <div class="type">
                  <span v-if="item.examinee_type!='普通类'" style="color: #C10B17;">{{item.examinee_type}}</span>
                </div>
                <div class="type"><span>{{item.batch_name}}</span>
                  <span>|</span>
                  <span>{{item.category_zn}}</span>
                  <span>|</span>
                  <span>{{item.type}}</span>
                </div>
              </div>
            </div>
            <div>{{item.province_name}}</div>
          </div>
        </div>

        <el-collapse accordion class="collapse2" v-model='activeCol' v-show="activeName!='first'">
          <el-collapse-item v-for="(item,index0) in data.list" :key="index0" :name=index0>
            <template slot="title">
              <div class="one flex" style="justify-content: space-between;">
                <div class="flex" @click="goDetail(item)"> <img
                    :src="'https://yunzhixuanpro.fw366.cn/'+item.school.badge_img">
                  <div class="info" @click="goDetail(item)">
                    <div><span class="name">{{item.school_name}}</span><span
                        class="address">院校代码：{{item.enroll_code}}</span>

                    </div>
                    <div class="type" style="margin-top: 0px;">
                      <span v-if="item.examinee_type!='普通类'" style="color: #C10B17;">{{item.examinee_type}}</span>
                    </div>
                    <div class="type" style="margin-top: 0px;"><span>{{item.batch_name}}</span>
                      <span>|</span>
                      <span>{{item.category_zn}}</span>
                      <span>|</span>
                      <span>{{item.type}}</span>
                      <span>|</span>
                      <span> {{item.province_name}}</span>
                    </div>
                  </div>
                </div>
                <div>

                  <div @click="showMajor(item)" class="open_zhaunye">专业</div>
                </div>
              </div>
            </template>
            <div class="majorList">
              <div class="flex zhuanye_one" v-for="(item0,index) in majorData">
                <div class="flex" style="margin-left: 40px;">

                  <div class="info flex"
                    style="justify-content: flex-start;flex-wrap: nowrap;width: 270px;margin-left: 30px;">
                    <div style="text-align: left">
                      <div><span class="name major_name">{{item0.major_name}}({{item0.major_detail}})</span>

                      </div>
                      <div class="type">
                        <span>学费:{{item0.money_year}}</span>
                        <span>学制:{{item0.school_year}}</span>
                        <span>招生人数:{{item0.num}}</span>

                      </div>
                      <div class="type">
                        <span>代码:{{item0.major_code}}</span>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="zhuanye_shuju">
                  <div class="shuju_one one1">
                    <p class="flex">
                      <span style="width: 100px;">{{item0.year}}年实际分</span>
                      <span style="width: 360px;">选科要求</span>
                      <span style="width: 120px;">选科对应专业</span>
                    </p>
                    <br>
                    <p class="flex">
                      <span style="width: 100px;">{{item0.score_actual}}</span>
                      <span style="width: 360px;" v-if="item0.limit!=null">
                        <span style="width: 120px;">首选：<span style="color: red;">{{item0.limit.limit1_zn}}</span></span>
                        <span style="width: 120px;">次选：<span style="color: red;">{{item0.limit.limit2_zn}}</span></span>
                        <span style="width: 100px;">再选：<span style="color: red;">{{item0.limit.limit3_zn}}</span></span>
                      </span>
                      <span style="width:  360px;color: red;" v-else>
                        -
                      </span>
                      <span v-if="item0.limit!=null&&item0.limit.check" style="width: 120px;">
                        <span style="color: #00aa00;font-weight: bold;"
                          v-show="item0.limit&&item0.limit.check&&item0.limit.check==true">符合</span>
                        <span style="color: red;font-weight: bold;"
                          v-show="item0.limit&&item0.limit.check&&item0.limit.check==false">不符</span>
                      </span>
                      <span v-else style="width: 120px;">-</span>
                    </p>
                  </div>

                </div>
                <div>


                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <pagination :current-page.sync="params.page" v-if="pageshow" :total="data.total"
          @currentchange='current_change'></pagination>
      </div>
      <div class="right">
        <sidebar></sidebar>
      </div>
    </main>
  </div>
</template>

<script>
  import sidebar from '../components/sidebar.vue'
  import pagination from '../components/pagination.vue'
  export default {
    data() {
      return {
        pageshow: true,
        majorData: [],
        activeName: 'first',
        options: [],
        value: '',
        activeCol: [],
        data: [],
        params: { //接口参数
          province_id: null,
          name: '',
          goal: '0',
          page: 1,
          mod: 1,
          first: '1',
          major_type_list: [],
          second: '2',
          third: '3'
        },
        userInfo: [],
        checkedCities: [2, 3],
        checkedCities1: [],
        kemu: [{
          label: '化学',
          value: 2
        }, {
          label: '生物',
          value: 3
        }, {
          label: '政治',
          value: 5
        }, {
          label: '地理',
          value: 6
        }],
        major: [],
        checkedNo: 0,
        radio: 1,
        major_type_list: []
      }
    },
    created() {
      if (this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName
      }
      this.$http.schoolGoal(this.params).then(res => {
        this.data = res.data
      })
      this.$http.majorTypeList().then(res => {
        this.major = res.data.list
        // this.$forceUpdate()
      })
      this.$http.getareaList().then(res => {
        this.options = res.data.list
      })
      this.$http.getUserInfo().then(res => {
        this.userInfo = res.data
        // this.radio = Number(this.userInfo.subject_type_1)

        // let data = res.data.subject_type_2.split(',').map(Number)
        // this.params.second = data[0]
        // this.params.third = data[1]
        // this.checkedCities = data

      })
      let data = {
        first: this.radio,
        second: this.checkedCities[0],
        third: this.checkedCities[1],
      }
      // this.$http.majorSubjectSearch(data).then(res => {
      //   this.data = res.data.list
      //   this.total = res.data.total
      //   this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
      // })
      this.$http.getCustomSearch({
        batch_name: '本科一批',
        mode: 'major'
      }).then(res => {
        this.majorList = res.data.list
      })
    },
    methods: {
      showMajor(item) {
        event.preventDefault();
        this.majorData = []
        this.$http.checkMajorCustomSearch({
          a_school_id: item.id,
          limit_mode: 2
        }).then(res => {
          this.majorData = res.data

        })
      },
      handleClick() {
        this.params.page = 1
        if (this.activeName == 'first') {
          this.params.mod = 1
          this.params.first = ''
          this.params.major_type_list = []
          this.params.second = ''
          this.params.third = ''
          this.$http.schoolGoal().then(res => {
            this.data = res.data

          })
        }
        this.pageshow = false; //让分页隐藏
        this.$nextTick(() => { //重新渲染分页
          this.pageshow = true;
        });
      },
      kemu_change() {
        this.activeCol = []
        if (this.radio != '' && this.checkedCities.length == 2 && this.activeName != 'first') {
          this.params.mod = 2
          this.params.first = this.radio
          this.params.major_type_list = this.major_type_list
          this.params.second = this.checkedCities[0]
          this.params.third = this.checkedCities[1]
          this.$http.schoolGoal(this.params).then(res => {
            this.data = res.data
          })
        }

      },
      submit() {
        this.$http.schoolGoal(this.params).then(res => {
          this.data = res.data
        })
      },
      handleCheckedCitiesChange() {

      },

      major_change(item, index) {
        this.checkedNo = index
        // console.log(index)
        // console.log(this.majorList[this.checkedNo].children)

      },
      current_change(e) {
        this.activeCol = []
        this.params.page = e
        this.$http.schoolGoal(this.params).then(res => {
          this.data = res.data
        })
        // if (this.params.province_id != '') {
        //   this.$http.schoolGoal({
        //     page: e,
        //     goal: this.params.goal,
        //     province_id: this.params.province_id
        //   }).then(res => {
        //     this.data = res.data
        //   })
        // }
      },
      headClass() {
        return 'background:#ececec'
      },
      search() {
        this.activeCol = []
        this.params.page = 1
        this.$http.schoolGoal({
          name: this.params.name,
        }).then(res => {
          this.data = res.data
        })
      },
      add_score(num) {
        this.activeCol = []
        this.params.goal = num
        this.params.page = 1
        this.$http.schoolGoal(this.params).then(res => {
          this.data = res.data
        })
      },
      change(e) {
        this.activeCol = []
        this.params.page = 1
        this.params.province_id = e
        this.$http.schoolGoal(this.params).then(res => {
          this.data = res.data
        })
      },
      goDetailMajor(item) {
        this.$router.push('/specialtyDetail?id=' + item.id)
      },
      goDetail(item) {
        this.$router.push('/schoolDetail?id=' + item.school_id)
      }
    },
    components: {
      sidebar,
      pagination
    }
  }
</script>

<style scoped lang="scss">
  .open_zhaunye {
    width: 74px;
    height: 32px !important;
    line-height: 32px !important;
    background: #C10B17;
    border-radius: 4px;
    border: none;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
  }

  .name {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .major_name {
    font-size: 14px;
  }

  .zhuanye_one {
    padding: 20px 0px;
    border-bottom: 1px solid #CCCCCC;
    width: 100%;
    justify-content: space-between;

    button {
      width: 74px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      color: #FFFFFF;
      background-color: #fff;
      color: #e9302d;
      border: 1px solid #e84c33;
    }
  }

  .table {
    width: 900px;
    border: 1px solid #ebeef5;

    .table-head {
      background-color: rgb(236, 236, 236);

      p {
        width: 100px;
        height: 40px;
        line-height: 40px;
        color: #909399;
        border-bottom: 1px solid #ebeef5;
      }
    }

    .table-main {
      width: 800px;
      color: #909399;
      justify-content: space-between;

      &>div {
        width: 100%;
        justify-content: space-around;
      }

      p {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .one {
    // justify-content: space-between;

    .info1 {
      margin-left: 68px;

      img {
        width: 20px;
        height: 20px;
        margin-top: 16px;
      }
    }

    text-align: left;
    border-bottom: 1px solid #F2F2F2;
    padding-bottom: 20px;
    margin-top: 20px;

    button {
      width: 74px;
      height: 32px !important;
      line-height: 32px !important;
      background: #C10B17;
      border-radius: 4px;
      border: none;
      font-weight: 400;
      color: #FFFFFF;
      // margin-left: 240px;
    }

    img {
      width: 67px;
      height: 67px;
      border-radius: 50%;
      margin-right: 12px;
    }

    .type {
      margin-top: 22px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }

    .name {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-right: 29px;
    }

    .address {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }
  }

  .schoolList {
    margin: 40px 0;
  }

  .filter {
    margin-top: 34px;
    text-align: left;

    span {
      padding: 5px 15px;
      height: 41px;
      border: 1px solid #CCCCCC;
      border-radius: 20px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-right: 22px;
    }

    .active {
      background: #C10B17;
      color: #FFFFFF;
      border: none;
    }
  }

  .search {
    justify-content: space-between;

    input {
      width: 280px;
      height: 35px;
      border: 1px solid #CCCCCC;
      border-radius: 6px;
      outline: none;
    }
  }

  .title {
    width: 300px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin: 37px 0 27px 0;
    text-align: left;
    text-indent: 20px;
  }

  .yuche {
    width: 1201px;
    // height: 123px;
    border: 1px solid #CCCCCC;

    p {
      margin: 26px;
      text-align: left;
      font-weight: 400;
      color: #333333;
      font-size: 24px;
    }

    span {
      color: #C10B17;
    }
  }

  .right {
    margin-left: 20px;
  }

  .content {
    width: 1280px;
    margin: 40px auto;
  }

  .more_major {
    font-size: 16px;
    margin: 0 !important;
    text-align: left;
  }

  .career_name {
    width: 165px;
    margin-bottom: 10px;
    display: inline-block;
  }

  .tab_active {
    color: #C10B17;
    font-weight: bold;
  }

  .major {
    text-align: left;
    width: 900px;

    span {
      margin-right: 30px;
    }
  }

  .major_one {
    position: relative;
    cursor: pointer;

  }


  .tip {
    color: #C10B17;
    text-align: left;
    margin-top: 20px;
  }

  .title {
    text-align: left;
    margin: 20px 0;
  }

  .one1 button {
    margin: 20px;
  }

  .one1 span {
    margin-right: 10px;
  }

  .tablemain {
    &>div {
      width: 100%;
    }

    button {
      width: 74px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      border: none;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 32px;
    }

    span {

      line-height: 60px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
  }



  .choose {
    margin-left: 50px;
  }

  .tablehead {
    text-align: left;
    position: sticky;
    top: 0;
    width: 100%;
    height: 51px;
    background: #FAFAFA;
    line-height: 51px;
    // margin-top: 20px;

    span {
      display: inline-block;
      // flex: 1;
      text-align: center;
      // margin-right: 20px;
    }
  }

  .two {
    img {
      width: 100px;
      height: 100px;
      margin-right: 30px;
    }
  }

  .filter {
    margin: 37px auto;

    width: 100%;

    select {
      margin-right: 10px;
    }

    .one {
      margin-right: 100px;
      padding: 10px 30px;
      border: 1px solid #E6E6E6;
      // padding: 30px;
      // height: 150px;

      span {
        margin-right: 20px;
      }

      &>div {
        margin-left: 30px;

        &>div {
          margin: 20px auto;
        }
      }
    }



    .el-dropdown-link {
      margin-bottom: 30px;
    }
  }
</style>
<style>
  .collapse2 .el-collapse-item__header {
    height: auto;
    line-height: auto;
    display: block;
  }

  .collapse2 .type {
    margin-top: 0px;
  }

  .el-collapse-item__arrow {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/view/futureEasy.vue